import { VueExtension } from '../../utils/extensions/vue';
import Tag from './tag.jsx';
import './tag.scss';

VueExtension.WithInstall(Tag);

export default Tag;
